import { Badge } from "@/core/components/ui/badge";
import { useTranslation } from "react-i18next";
import IconIaStars from "@/assets/icons/icon-ia-stars.svg?react";

export function BadgeIA({ text }: { text?: string }) {
  const [translate] = useTranslation(["core"]);

  return (
    <div
      className="inline-flex rounded-[8px] p-[1px] bg-[radial-gradient(circle_at_50%_50%,_theme(colors.aiBeige.50)_0%,_theme(colors.aiBeige.100)_28%,_theme(colors.aiBlue.300)_100%)]"
      style={{ boxSizing: "border-box" }}
    >
      <Badge
        variant="outline"
        className="flex items-center gap-2 rounded-[7px] bg-white text-aiBlue-800 border-none min-w-0"
      >
        <IconIaStars className="w-4 h-4" />
        <span className="text-xs font-medium">
          {text ? text : translate("badge-ia-analysis")}
        </span>
      </Badge>
    </div>
  );
}
